import ConvertKitForm from "convertkit-react";
import { useRef, useState, useEffect } from "react";

const NEWSLETTER_TOPICS = [
  "PUBLISHED ORIGINAL PIECES",
  "NEWLY AVAILABLE PRINTS",
  "UPCOMING EVENTS",
  "BEHIND-THE-SCENES INFO",
];

interface NewsletterFormProps {
  formId: number;
  className?: string;
  formClassName?: string;
  titleClassName?: string;
  rotatorClassName?: string;
  title?: string;
  submitText?: string;
}

export function NewsletterForm({
  formId,
  className,
  formClassName,
  titleClassName,
  rotatorClassName,
  title = "JOIN THE NEWSLETTER!",
  submitText = "SUBSCRIBE",
}: NewsletterFormProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % NEWSLETTER_TOPICS.length);
        setIsVisible(true);
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const el = formRef.current;
    if (!el) return;
    el.querySelectorAll<HTMLInputElement>("input").forEach((input) => {
      input.required = true;
    });
  }, []);

  return (
    <div ref={formRef} className={className}>
      <div className="mb-2 text-center">
        <h1
          className={`overflow-hidden text-lg font-bold tracking-tight whitespace-nowrap ${titleClassName}`}
        >
          {title}
        </h1>
        <div
          className={`mt-1 mb-3 flex items-center justify-center overflow-hidden ${rotatorClassName}`}
        >
          <span
            className={`text-sm whitespace-nowrap transition-opacity duration-500 ${
              isVisible ? "opacity-100" : "opacity-0"
            }`}
          >
            {NEWSLETTER_TOPICS[currentIndex]}
          </span>
        </div>
      </div>
      <div className={formClassName}>
        <ConvertKitForm
          formId={formId}
          template="minimal"
          namePlaceholder="Your Name"
          emailPlaceholder="Email Address"
          submitText={submitText}
          className="convertkit-form"
        />
      </div>
    </div>
  );
}
